__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "sptuiExternal";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@design-systems/canvas-ui", "8.2.4", function() { return Promise.all([__webpack_require__.e(964), __webpack_require__.e(580), __webpack_require__.e(214), __webpack_require__.e(283), __webpack_require__.e(205)]).then(function() { return function() { return __webpack_require__(1214); }; }); });
			register("@enterprise-ui/canvas-ui-react", "7.22.2", function() { return Promise.all([__webpack_require__.e(964), __webpack_require__.e(247), __webpack_require__.e(283), __webpack_require__.e(205), __webpack_require__.e(374)]).then(function() { return function() { return __webpack_require__(7247); }; }); });
			register("@measurement/opentelemetry-web", "5.5.0", function() { return Promise.all([__webpack_require__.e(486), __webpack_require__.e(392)]).then(function() { return function() { return __webpack_require__(5486); }; }); });
			register("@praxis/component-auth", "27.0.6", function() { return Promise.all([__webpack_require__.e(740), __webpack_require__.e(283), __webpack_require__.e(305), __webpack_require__.e(17)]).then(function() { return function() { return __webpack_require__(740); }; }); });
			register("@spt-platform/components", "5.4.0", function() { return Promise.all([__webpack_require__.e(580), __webpack_require__.e(877), __webpack_require__.e(246), __webpack_require__.e(283), __webpack_require__.e(205), __webpack_require__.e(305), __webpack_require__.e(493), __webpack_require__.e(885), __webpack_require__.e(195)]).then(function() { return function() { return __webpack_require__(1246); }; }); });
			register("axios", "1.20.0", function() { return __webpack_require__.e(635).then(function() { return function() { return __webpack_require__(4635); }; }); });
			register("react-dom", "18.3.1", function() { return Promise.all([__webpack_require__.e(108), __webpack_require__.e(283)]).then(function() { return function() { return __webpack_require__(8108); }; }); });
			register("react-router-dom", "7.18.4", function() { return Promise.all([__webpack_require__.e(191), __webpack_require__.e(283), __webpack_require__.e(205)]).then(function() { return function() { return __webpack_require__(8191); }; }); });
			register("react", "18.3.1", function() { return __webpack_require__.e(685).then(function() { return function() { return __webpack_require__(6685); }; }); });
			register("styled-components", "6.6.0", function() { return Promise.all([__webpack_require__.e(732), __webpack_require__.e(283)]).then(function() { return function() { return __webpack_require__(732); }; }); });
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};